import styled, { css } from 'styled-components';

import { Container as BaseContainer } from '../SupportBlock.styled';

export const Container = styled(BaseContainer)`
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Text = styled.p`
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 700;
    margin: 0;
`;

export const Information = styled.span`
    ${({ theme }) => css`
        margin-top: 0.5rem;
        font-size: 1.5rem;
        font-weight: 300;
        display: block;
        font-family: ${theme.fonts.secondary};
        color: ${theme.colors.primary.hex};

        @media ${theme.breakpoints.large.media} {
            margin-top: 1rem;
            font-size: 2rem;
        }
    `}
`;
